export const defaultMetaData = {
    robots: "index, follow, noarchive, max-snippet:-1, max-image-preview:large, max-video-preview:-1",
    viewport: "width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no"
};

/**
 * Updates a meta data object to set a no follow header for search machines.
 */
export const withNoIndex = (inMetaData: any): any => ({
    ...inMetaData,
    robots: "noindex, follow, noarchive, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
});
